 


theme.guestCheckoutBday = (function () {
  var selectors = {
    checkout_btn: '#guest_submit',
    dobField:     '#gc_birthday',
    dobDay:       '#gc_birthday--day',
    dobMonth:     '#gc_birthday--month',
    dobYear:      '#gc_birthday--year',
    dobInputs:    '.gc_dob-picker__input'
  };

  $( selectors.checkout_btn ).on('click', function(e){
    var value = validateDateOfBirth(e);
    
    if ( value != '' ) {
      
      $.post("/cart/update.js", {"note": value})
      .done(function() {
        window.location.href = "/checkout";
      })
      .fail(function() {
        window.location.href = "/checkout";
      });
    }
  });
  
  function pad(number, width, padding) {
    padding = padding || '0';
    number  = number + '';

    return number.length >= width
      ? number
      : new Array(width - number.length + 1).join(padding) + number;
  }

  function buildDateOfBirth() {
    var day = $(selectors.dobDay).val();
    var month = $(selectors.dobMonth).val();
    var year = $(selectors.dobYear).val();
    
    year = year == '' ? null : year;

    // Check to see whether any of the values are null
    if ([day, month, year].indexOf(null) > -1) {
      return null;
    }

    // Don't return it if the year is just ridiculous.
    if (year < 1900) {
      return null;
    }

    // Pad the day and month with 0s
    day   = pad(day, 2);
    month = pad(month, 2);

    return year + '-' + month + '-' + day;
  }

  // Validate the date of birth and make sure the customer is at least
  // eighteen years old.
  function validateDateOfBirth(e) {
    var inputs = $(selectors.dobInputs);
    var value = buildDateOfBirth();

    // Check to see whether we have a value yet
    if (value == null) {
      e.preventDefault();

      return inputs.each(function () {
        $(this).addClass('input--validated').addClass('invalid');
        $('.guest_checkout_error').html("Please enter a valid date.").show();
      });
    }

    // Get the dates
    var age = moment().subtract(18, 'years'),
        dob = moment(value);

    // Make sure we've got a valid date of birth
    if (! dob.isValid()) {
      e.preventDefault();
      
      return inputs.each(function () {
        $(this).addClass('input--validated').addClass('invalid');
         $('.guest_checkout_error').html("Please enter a valid date.").show();
      });
    }

    // And finally, check that the user is 18 years old
    if (dob.isAfter(age)) {
      e.preventDefault();
      
      return inputs.each(function () {
        $(this).addClass('input--validated').addClass('invalid');
         $('.guest_checkout_error').html("You must be 18 years old to checkout.").show();
      });
    }
    
    $(selectors.dobField).val(value);  
    
    return value;

//     return inputs.each(function () {
//       $(this).removeClass('input--validated').removeClass('invalid');
//       $('.guest_checkout_error').hide();
//     });
  }
})();

theme.customerRegistration = (function () {
  var selectors = {
    registerForm: '#create_customer',
    dobField:     '#birthday',
    dobDay:       '#birthday--day',
    dobMonth:     '#birthday--month',
    dobYear:      '#birthday--year',
    dobInputs:    '.dob-picker__input'
  };

  // Add our event listeners
  $(selectors.dobField)
    .add(selectors.dobDay)
    .add(selectors.dobMonth)
    .add(selectors.dobYear)
    .on('keyup change', validateDateOfBirth);

  function pad(number, width, padding) {
    padding = padding || '0';
    number  = number + '';

    return number.length >= width
      ? number
      : new Array(width - number.length + 1).join(padding) + number;
  }

  function buildDateOfBirth() {
    var day = $(selectors.dobDay).val();
    var month = $(selectors.dobMonth).val();
    var year = $(selectors.dobYear).val();

    year = year == '' ? null : year;

    // Check to see whether any of the values are null
    if ([day, month, year].indexOf(null) > -1) {
      return null;
    }

    // Don't return it if the year is just ridiculous.
    if (year < 1900) {
      return null;
    }

    // Pad the day and month with 0s
    day   = pad(day, 2);
    month = pad(month, 2);

    return year + '-' + month + '-' + day;
  }

  // Validate the date of birth and make sure the customer is at least
  // eighteen years old.
  function validateDateOfBirth() {
    var inputs = $(selectors.dobInputs);
    var value = buildDateOfBirth();

    // Check to see whether we have a value yet
    if (value == null) {
       return inputs.each(function () {
        this.setCustomValidity("Please enter a valid date.");
      });
    }

    // Get the dates
    var age = moment().subtract(18, 'years'),
        dob = moment(value);

    // Make sure we've got a valid date of birth
    if (! dob.isValid()) {
      return inputs.each(function () {
        this.setCustomValidity("Please enter a valid date.");
      });
    }

    // And finally, check that the user is 18 years old
    if (dob.isAfter(age)) {
      return inputs.each(function () {
        this.setCustomValidity("You must be 18 years old to create an account.");
      });
    }

    $(selectors.dobField).val(value);

    return inputs.each(function () {
      this.setCustomValidity("");
    });
  }
})();
